import Alert from 'reactstrap/lib/Alert';

export default function PreviewingAlert({ show = false }) {
    if (!show) {
        return;
    }

    return <Alert color="warning">You are previewing this application and therefore cannot submit any entered data or payment.</Alert>;
}
